import { render, staticRenderFns } from "./CustomFieldNumberEditor.vue?vue&type=template&id=197acc9f&"
import script from "./CustomFieldNumberEditor.vue?vue&type=script&lang=ts&"
export * from "./CustomFieldNumberEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports